import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { ConfigState } from '../../../redux/modules/config/reducer';

export type API = 'platform' | 'auth';

const buildRequestUrl = (
  requestConfig: AxiosRequestConfig,
  appConfig: ConfigState,
) => {
  if (!appConfig?.useAPIDomains) return requestConfig.url;

  const testAPIPath = (pathComponent: string) =>
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    requestConfig.url.indexOf(`/${pathComponent}`) === 0;

  const buildFullUrlFromAPIUrl = (apiUrl: string) => {
    if (!apiUrl) {
      console.error(
        'PWT is configured to use full urls, but no API domain is configured for request URL: ' +
          requestConfig.url,
      );
      return requestConfig.url;
    }

    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const indexOfSecondPathPart = requestConfig.url.indexOf('/', 1);
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const withoutAPIPathPart = requestConfig.url.substring(
      indexOfSecondPathPart,
    );
    return `${apiUrl}${withoutAPIPathPart}`;
  };

  // by default, the first chunk of the path determines the base uri to reroute to
  if (testAPIPath('api')) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return buildFullUrlFromAPIUrl(appConfig.apiBaseUri);
  } else if (testAPIPath('auth')) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return buildFullUrlFromAPIUrl(appConfig.oauthBaseUri);
  } else if (testAPIPath('phc')) {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return buildFullUrlFromAPIUrl(appConfig.appsApiBaseUri);
  } else {
    console.error(
      `PWT is configured to use full domains, but no api domain was configured for request url: ${requestConfig.url}`,
    );
    return requestConfig.url;
  }
};

const withConfiguredBaseUrl =
  (appConfig: ConfigState) => (axios: AxiosInstance) => {
    axios.interceptors.request.use(requestConfig => {
      return {
        ...requestConfig,
        url: buildRequestUrl(requestConfig, appConfig),
      };
    });

    return axios;
  };

export default withConfiguredBaseUrl;
